import { useLocation } from 'react-router-dom';
import { Plane } from 'lucide-react';
import { motion } from 'framer-motion';
import { useFlightLog } from '../contexts/FlightLogContext';
import { useAuth } from '../contexts/AuthContext';

// Pages where the FAB would conflict with other UI
const HIDDEN_PATHS = ['/tracker', '/admin'];

/**
 * Floating Action Button — visible on mobile only (hidden lg:).
 * Tapping it opens the global Flight Log modal from anywhere in the app.
 */
export default function MobileFAB() {
  const { open } = useFlightLog();
  const { user }  = useAuth();
  const { pathname } = useLocation();

  if (HIDDEN_PATHS.some(p => pathname.startsWith(p))) return null;

  // Position above mobile bottom nav (bottom nav only shows for logged-in users)
  const bottomClass = user ? 'bottom-[88px]' : 'bottom-6';

  return (
    <div className={`fixed ${bottomClass} right-4 z-40 lg:hidden`}>
      <motion.button
        onClick={open}
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.92 }}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 400, damping: 22, delay: 0.5 }}
        className="relative w-14 h-14 rounded-full fly-btn-glossy flex items-center justify-center"
        data-testid="mobile-fab-log-flight"
        aria-label="Log a flight"
      >
        {/* Subtle pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#FF4500]/30 animate-ping opacity-60" />
        <Plane className="w-6 h-6 text-white relative z-10" />
      </motion.button>
    </div>
  );
}
